import { Badge } from "@/components/ui/badge";

/**
 * Marks a channel that admits guests, for the organisation's own members:
 * a guest sees only external channels, so it never shows to them.
 */
export function ExternalChannelBadge({ size = "default" }: { size?: "default" | "xs" }) {
  return (
    <Badge
      variant="outline"
      size={size}
      className="shrink-0"
      title="Guests from outside your organisation can be invited to this channel and see what is in it."
    >
      External
    </Badge>
  );
}
